import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseLocalStorageService {

  private storge = window.localStorage;    

  constructor() {}

  getItem(key: string) {
      return this.storge.getItem(key);
  }

  setString(key: string, value: string) {
      this.storge.setItem(key, value);
  }

  setObject(key: string, data: any) {
    var valueJsonStr = JSON.stringify(data)
    this.storge.setItem(key, valueJsonStr);
  }

  delete(key: string) {
      this.storge.removeItem(key);
  }

  getString(key: string): string {
    try {
      let stringItem=this.storge.getItem(key)
      if(stringItem!==null)
        {
          return stringItem;
        }
        else
        return "";
        
    } catch (ex) {
        console.log(ex);

        return "";
    }
  }

  getObject<T>(key:string): T|null {
    let info: T;
    let object =this.storge.getItem(key);
    let defaultObj=null;
    if(object!==null)
        {
            let objString=object.toString();
            try {
                info = JSON.parse(objString);
                return info;
            } catch (ex) {
                console.log(ex);
        
                return defaultObj;
            }

        }
        return defaultObj;
    
  }

}
